// import { gql } from '@apollo/client';
import gql from 'graphql-tag';


export const USER_QUERY = gql`
  query UserQuery {
    me {
      id
      dateJoined
      email
      firstName
      lastName
      username
      isStaff
      orgDetails {
        id
        segment
        market
        jobFunction
        persona {
          id
          name
        }

      }
    }
    preferences {
      id
      sidebar
      layout {
        id
        name
      }
    theme {
      id
      name
      }
    }
  }
`;

export const USER_PERMISSIONS_QUERY = gql`
query UserPermissionQuery {
  me {
    id
    isActive
    isStaff
  }
}
`;




export const USER_PREFERENCES_QUERY = gql`
query UserPreferencesQuery {
  preferences {
    id
    sidebar
    layout {
      name
      id
    }
    theme {
      id
      name
    }
  }
}
`;


export const USER_RECENT_VIEWS_QUERY = gql`
query UserRecentViews {
  me {
    id
    recentViews {
      id
      visitTime
      report {
        id
        visitCount
        lastVisit
        segment {
          id
          name
        }
        capability {
          id
          name
        }
        region {
          id
          name
        }
        market {
          id
          name
        }
        personas {
          name
        }
        solution {
          id
          name
          description
          businessProcess {
            __typename
            pk
          }
        }
        title
        ownerName
        metrics {
          __typename
          name
        }
      }
    }
  }
}
`;


export const USER_FAVOURITES_QUERY = gql`
query UserFavouritesQuery {
  me {
    id
    favourites {
      id
      creationTime
      report {
        id
        segment {
          id
          name
        }
        capability {
          id
          name
        }
        region {
          id
          name
        }
        market {
          id
          name
        }
        personas {
          id
          name
        }
        solution {
          id
          name
          description
          businessProcess {
            __typename
            pk
          }
        }
        title
        ownerName
        metrics {
          __typename
          name
        }
      }
    }
  }
}
`;

export const ALL_PREFERENCES_QUERY = gql`
query AllPreferencesQuery {
  me {
    id
  }
  themeList {
    name
    id
    title
  }
  layoutList {
    id
    name
    title
  }
}
`;



export const VALIDATE_ACCESS_TOKEN_QUERY = gql`
query ValidateAccessToken($token: String = "") {
  validateAccessToken(token: $token)
}
`;


export const REVOKE_ACCESS_TOKEN_QUERY = gql`
query RevokeAccessToken($token: String) {
  revokeToken(token: $token)
}
`;




export const CREATE_PREFERENCE_MUTATION = gql`
mutation CreatePreferenceMutation($userId: GlobalID!, $themeId: GlobalID!, $layoutId: GlobalID!, $sidebar: Boolean!) {
  createPreference(
    input: {sidebar: $sidebar, user: {id: $userId}, theme: {id: $themeId}, layout: {id: $layoutId}}
  ) {
    ... on PreferenceType {
      id
      sidebar
      user {
        id
      }
      layout {
        id
        name
      }
      theme {
        id
        name
      }
    }
  }
}
`;


export const UPDATE_SIDEBAR_MUTATION = gql`
mutation UpdateSidebar($id: GlobalID!,$userId: GlobalID!, $sidebar: Boolean!) {
  updatePreferences(
    input: {id: $id, user:{id: $userId},sidebar: $sidebar}
  ) {
    ... on PreferenceType {
      id
      sidebar
    }
  }
}
`;

export const UPDATE_LAYOUT_MUTATION = gql`
mutation UpdateLayout($id: GlobalID!,$userId: GlobalID!, $layout_id: GlobalID!) {
  updatePreferences(input: {id: $id, user:{id: $userId},layout: {id: $layout_id}}) {
    ... on PreferenceType {
      id
      layout {
        name
      }
    }
  }
}
`;

export const UPDATE_THEME_MUTATION = gql`
mutation UpdateTheme($id: GlobalID!,$userId: GlobalID!, $theme_id: GlobalID!) {
  updatePreferences(input: {id: $id, user:{id: $userId},theme: {id: $theme_id}}) {
    ... on PreferenceType {
      id
      theme {
        name
      }
    }
  }
}
`;

export const ADD_FAVOURITE_MUTATION = gql`
mutation AddFavourite($userID: GlobalID!, $reportID: GlobalID!) {
  addFavourite(input: {user: {id: $userID}, report: {id: $reportID}}) {
    ... on FavouriteType {
      id
    }
  }
}
`;

export const REMOVE_FAVOURITE_MUTATION = gql`
mutation RemoveFavourite($favouriteID: GlobalID!) {
  removeFavourite(input: {id: $favouriteID}) {
    ... on FavouriteType {
      id
    }
  }
}
`;

export const ADD_RECENT_MUTATION = gql`
mutation AddRecent($userID: GlobalID!, $reportID: GlobalID! ) {
  addRecent(input: {user: {id: $userID}, report: {id: $reportID}, }) {
    ... on RecentViewsType {
      id
    }
  }
}
`;

export const SAVE_SEARCH_MUTATION = gql`
  mutation CreateSearch($location: String!, $search: String!) {
    createSearch(search: $search, location: $location) {
      user {
        email
      }
      keyword {
        name
      }
      createdAt
      id
    }
  }
`;


export const REMOVE_RECENT_MUTATION = gql`
mutation RemoveRecent($recentViewID: GlobalID!) {
  removeRecent(input: {id: $recentViewID}) {
    ... on RecentViewsType {
      id
    }
  }
}
`;


export const USER_NOTIFICATION_QUERY = gql`
query GetAllUserNotifications($isSeen: Boolean = false) {
  me {
    id
    notifications(filters: {isSeen: $isSeen}) {
      id
      notification
      isSeen
    }
  }
}
`;

export const USER_NOTIFICATION_SUBSCRIPTION = gql`
subscription SubscribeToUserNotifications {
  allNotificationsChannel {
    id
    notification
    isSeen
  }
}
`;


// TODO: #26 Implement graphql channels based notification
//Sample mutation queries
// mutation MessageToSachin {
//   sendNotificationMessage(
//     message: "kya baat hai veere "
//     user: { email: "sachin.mahajan1@effem.com"}
//   )
// }

// mutation MessageToAdmin {
//   sendNotificationMessage(
//     message: "hello admin ji fir se  "
//     user: { email: "admin@mysupplychain.azurewebsites.net"}
//   )
// }